import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { Observable, Subject, combineLatest, distinctUntilChanged, map, of, startWith, switchMap, takeUntil } from 'rxjs';
import { SafeLiftService } from 'src/app/services/app/safelift.service';
import { App_DisableNew, App_FormCreatorJson, App_FormFieldCasesDynamiques, App_FormFieldCheckbox, App_FormFieldDrawing, App_FormFieldInputNumber, App_FormFieldInputText, App_FormFieldLabel, App_FormFieldListe, App_FormFieldRadio, App_FormFieldTextArea, App_FormSketchField, App_TrueField } from 'src/app/utils/interfaces';
import { Type_Field, Type_FieldOrLabel } from 'src/app/utils/types';
import { buildDisableNewConstraintResults } from 'src/app/utils/utils';

@Component({
  selector: 'app-c-field-status',
  templateUrl: './c-field-status.component.html',
  styleUrls: ['./c-field-status.component.scss'],
})
export class CFieldStatusComponent implements OnInit, OnDestroy {
  @Input({ required: true }) display!: App_FormCreatorJson; // TODO-pf? retirer + remplacer quand et si pertinent
  @Input({ required: true }) field!: Type_Field;
  @Input({ required: true }) cFormControl!: AbstractControl;
  @Input({ required: true }) forms!: FormGroup;
  @Input({ required: true }) previousField!: AbstractControl | true;
  
  hide = false;
  destroyComponent$: Subject<boolean> = new Subject();

  constructor(
    private safeLiftService: SafeLiftService
  ) { }

  ngOnInit() {
    if (this.field.disable_new?.hideIfDisabled === true) {
      this.hide = this.safeLiftService.isFieldHidden(this.field as App_TrueField, this.forms, this.display);
    }
    if (this.field.disable_new !== undefined) {
      this.setConditionalDisable(this.field.disable_new)
    } else if (this.field.disable !== undefined) {
      this.setConditionalDisableOld(this.field.disable.options)
    } else {
      this.setOnlyBasedOnPreviousField()
    }
  }

  ngOnDestroy() {
    this.destroyComponent$.next(true);
  }

  setConditionalDisableOld(disableOptions: {
    fromControl: any;
  //   TODO-pf V2 remettre
  //   onValue: {
  //     type: "function";
  //     function: string;
  //   } | {
  //     type: "regexp";
  //     regexp: string;
  //   } | {
  //     type: "value";
  //     value: any;
  //   } | {
  //     type: "values";
  //     values: any[];
  //   };
    onValue: any[];
  }[]) {
    const enables = disableOptions.reduce<Observable<boolean>[]>((acc, x) => {
      const field = this.safeLiftService.findFieldInFormEntity(this.forms, x.fromControl)
      if (field instanceof AbstractControl) {
        const enable$ = field.valueChanges.pipe(
          startWith(field.value),
          map(val => {
            //   TODO-pf V2 remettre
            // if (x.onValue.type === 'values') {
            //   return x.onValue.values.includes(val)
            // } else if (x.onValue.type === 'function') {
            //   // TODO-pf
            // } else if (x.onValue.type === 'regexp') {
            //   // TODO-pf
            // } else if (x.onValue.type === 'value') {
            //   return x.onValue.value === val;
            // }
            // return false;
            return x.onValue.includes(val);
          }),
          distinctUntilChanged(),
        );
        return [
          ...acc,
          enable$
        ]
      }
      return acc;
    }, []);
    combineLatest(enables).pipe(
      takeUntil(this.destroyComponent$),
      switchMap(vals => this.actionBasedOnPreviousField(this.previousField).pipe(
        map(action => ({ vals, action }))
      ))
    ).subscribe(({ vals, action }) => {
      if (vals.every(val => val)) {
        if (this.cFormControl.disabled && action.action === 'enable' || action.action === null) {
          this.cFormControl.enable();
        }
      } else {
        if (this.cFormControl.enabled && action.action === 'disable' || action.action === null) {
          this.cFormControl.disable();
        }
      }
    })
  }

  setConditionalDisable(disable_new: App_DisableNew) {
    const operation = disable_new.operation;
    const constraints = disable_new.constraints;
    if (typeof operation === 'string') {
      const matches = operation.match(/\$[\w]+/g)
      if (Array.isArray(matches)) {
        if (
          Array.isArray(constraints)
          && constraints.length > 0
          && constraints.every(constraint =>
            typeof constraint.champ === 'string' &&
            constraint.champ !== this.field.name &&
            typeof constraint.id === 'string' &&
            typeof constraint.type === 'string' &&
            constraint.value !== undefined
          )
        )
        // if (
        //   Array.isArray(constraints)
        //   && constraints.length > 0
        //   && constraints.every(constraint => typeof constraint.champ === 'string' && constraint.champ !== this.field.name && typeof constraint.id === 'string' && typeof constraint.type === 'string' && typeof constraint.value === 'string')
        //   && matches.every(matchStr => constraints.find(constraint => constraint.id === matchStr))
        // ) 
        {
            const observables = constraints.reduce<(Observable<{ id: string, champNom: string, valuetoReplace: string, constraintValue: any, field: AbstractControl }> | undefined)[]>((acc, constraint) => {
            const field = this.safeLiftService.findFieldInFormEntity(this.forms, constraint.champ);
            const champ = this.safeLiftService.findFieldinFormParams(this.display, constraint.champ); // TODO-pf exploiter ?
            if (field instanceof AbstractControl) {
              console.log('[DEBUG] valueChanges - champ:', constraint.champ, 'valeur:', constraint.value, 'attendu:', constraint.value, 'operator:', constraint.operator);

              return [
                ...acc,
                field.valueChanges.pipe(
                  startWith(field.value),
                  distinctUntilChanged()
                ).pipe(
                //   map(value => ({
                  
                //   id: constraint.id,
                //   champNom: constraint.champ,
                //   champ,
                //   valuetoReplace: constraint.value,
                //   constraintValue: value,
                //   field
                // }))
                map(value => {
                  console.log('[DEBUG] ➤ Valeur captée pour le champ:', constraint.champ);
                  console.log('        → Actuelle:', value);
                  console.log('        → Attendue:', constraint.value);
                  return {
                    id: constraint.id,
                    champNom: constraint.champ,
                    champ,
                    valuetoReplace: constraint.value,
                    constraintValue: value,
                    field
                  };
                })
              )
              ]
            }
            return [...acc, undefined]
          }, []);
          if (observables.every(obs => obs instanceof Observable)) {
            const obs$ = combineLatest(
              observables.map(_ => (_ as Observable<{ id: string, champNom: string, champ: Type_FieldOrLabel | undefined, valuetoReplace: string, constraintValue: any, field: AbstractControl }>)/*.pipe(tap(x => console.log('x', x)))*/)
            ).pipe(
              takeUntil(this.destroyComponent$),
              map((ctrlsFields) => {
                try {
                  const arrayOfTransformedValues = buildDisableNewConstraintResults(
                    operation,
                    constraints,
                    (champ) => {
                      const c = this.safeLiftService.findFieldInFormEntity(this.forms, champ);
                      return c instanceof AbstractControl ? c : undefined;
                    },
                    (champ) => this.safeLiftService.findFieldinFormParams(this.display, champ),
                  );
                  const evaluatedOperation = this.evaluateOperation(operation, arrayOfTransformedValues);
                  return evaluatedOperation;
                } catch (error) {
                  return false;
                }
              }),
              distinctUntilChanged(),
            );
            obs$.pipe(
              switchMap(res => this.actionBasedOnPreviousField(this.previousField).pipe(
                map(action => ({ res, action }))
              ))
            ).subscribe(({ res, action }) => {
              console.log('[DEBUG] Résultat final de l’opération conditionnelle:', res, '| Action basée sur previousField:', action);
              if (disable_new.hideIfDisabled === true) {
                  this.hide = !res;
                }
              if (res) {
                if (this.cFormControl.disabled && (action.action === 'enable' || action.action === null)) {
                  this.cFormControl.enable();
                }
              } else {
                if (this.cFormControl.enabled && (action.action === 'disable' || action.action === null)) {
                  this.cFormControl.disable();
                }
              }
            });
          }
        }
      }
    }
  }

  /**
   * cette fonction retourne un observable qui dicte une action à appliquer au champ courant
   * la valeur null est appliquée pour indiquer que peu importe
   * (soit qu'il n'y a pas de previousField, soit que le status du champ précédent ne dicte pas une action)
   */
  actionBasedOnPreviousField(previousField: AbstractControl | boolean): Observable<{ action: 'enable' | 'disable' | null }> {
    if (previousField instanceof AbstractControl) {
      return previousField.statusChanges.pipe(
        startWith(previousField.status),
        distinctUntilChanged(),
        takeUntil(this.destroyComponent$),
        map(status => {
          if (status === 'VALID') {
            return {
              action: 'enable'
            }
          } else if (status === 'INVALID' || status === 'DISABLED') {
            return {
              action: 'disable'
            }
          } else {
            return {
              action: null
            }
          }
        })
      )
    } else {
      return of({ action: null })
    }
  }

  /**
   * Écoute le status du champ précédent uniquement
   * enable ou disable le champ en fonction de l'action reçue
   */
  setOnlyBasedOnPreviousField() {
    if (this.previousField instanceof AbstractControl) {
      this.actionBasedOnPreviousField(this.previousField).subscribe(action => {
        if (action.action === 'enable' && this.cFormControl.disabled) {
          this.cFormControl.enable();
        } else if (action.action === 'disable' && this.cFormControl.enabled) {
          this.cFormControl.disable();
        }
      })
    }
  }

  evaluateOperation(operation: string, arrayOfTransformedValues: { id: string, value: boolean }[]) {
    const operationReplaced = operation.replace(/\$[\w]+/g, str => {
      const found = arrayOfTransformedValues.find(v => v?.id === str);
      if (found) {
        return found.value.toString();
      }
      return 'false';
    });
    try {
      const evaluated = eval(operationReplaced);
      console.log('[DEBUG] Operation brute:', operation, '| Remplacée:', operationReplaced, '| Résultat:', evaluated);

      if (typeof evaluated === 'boolean') {
        return evaluated;
      } else {
        return false;
      }
    } catch (error) {
      return false
    }
  }

}
